import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
   CertificationClientComponent,
   ListCustomersComponent
} from './modules/pages/customers/list-customers/list-customers.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatSliderModule } from '@angular/material/slider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { AddClientComponent } from './modules/pages/customers/add-client/add-client.component';
import { AddOrderComponent } from './modules/pages/orders/add-order/add-order.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { DetailSlotComponent } from './modules/pages/pub/detail-slot/detail-slot.component';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { AngularMaterialModule } from './angular-material.module';
import { MatProgressButtonsModule } from 'mat-progress-buttons';
import localeFrExtra from '@angular/common/locales/extra/fr';
// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import {appInitializeEnv, appInitializer, ErrorInterceptor, JwtInterceptor} from './_helpers';
import { AuthenticationService } from './_services';
import { ToastrModule } from 'ngx-toastr';
// import {CreateAccountComponent} from './modules/auth/create-account/create-account.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RecaptchaModule } from 'ng-recaptcha';
import { NgImageSliderModule } from 'ng-image-slider';
import { AgGridModule } from 'ag-grid-angular';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CovalentCommonModule } from '@covalent/core/common';
import { CovalentLayoutModule } from '@covalent/core/layout';
import { CovalentMediaModule } from '@covalent/core/media';
import { CovalentExpansionPanelModule } from '@covalent/core/expansion-panel';
import { CovalentStepsModule } from '@covalent/core/steps';
import { CovalentDialogsModule } from '@covalent/core/dialogs';
import { CovalentLoadingModule } from '@covalent/core/loading';
import { CovalentSearchModule } from '@covalent/core/search';
import { CovalentPagingModule } from '@covalent/core/paging';
import { CovalentNotificationsModule } from '@covalent/core/notifications';
import { CovalentMenuModule } from '@covalent/core/menu';
import { CovalentDataTableModule } from '@covalent/core/data-table';
import { CovalentMessageModule } from '@covalent/core/message';
import { CovalentFileModule } from '@covalent/core/file';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnShowSlotComponent } from "./modules/pages/pub/planification/on-show-slot/on-show-slot.component";
import { UniquePipe } from "./shared/pipes/unique.pipe";
import { GroupByPipe } from "./shared/pipes/group-by.pipe";
import { AngularEditorModule } from '@kolkov/angular-editor';
import { OverlayModule } from '@angular/cdk/overlay';
import { SharedModule } from "./shared/shared.module";
import { JWT_OPTIONS, JwtHelperService } from "@auth0/angular-jwt";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import {EnvService} from './_services/configurations/env.service';
import { OauthCallbackComponent } from './modules/auth/oauth-callback/oauth-callback.component';


registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

@NgModule({
   declarations: [
      AppComponent,
      ListCustomersComponent,
      CertificationClientComponent,
      AddClientComponent,
      AddOrderComponent,
      OnShowSlotComponent,
      DetailSlotComponent,
      GroupByPipe,
      UniquePipe,
      OauthCallbackComponent
   ],
   imports: [
      BrowserModule,
      NgxPaginationModule,
      PdfViewerModule,
      RecaptchaModule,
      NgImageSliderModule,
      DataTablesModule.forRoot(),
      AppRoutingModule,
      NgSelectModule,
      MatProgressSpinnerModule,
      // Material
      MatAutocompleteModule,
      MatButtonModule,
      MatCardModule,
      MatChipsModule,
      MatDatepickerModule,
      MatDialogModule,
      MatExpansionModule,
      MatGridListModule,
      MatIconModule,
      MatInputModule,
      MatListModule,
      MatProgressBarModule,
      MatRadioModule,
      MatRippleModule,
      MatSelectModule,
      MatSidenavModule,
      MatSliderModule,
      MatSnackBarModule,
      MatStepperModule,
      MatTableModule,
      MatTabsModule,
      MatToolbarModule,
      MatTooltipModule,
      MatNativeDateModule,
      FormsModule,
      AngularMaterialModule,
      ReactiveFormsModule,
      BrowserAnimationsModule,
      /** Material Modules */
      MatButtonModule,
      MatListModule,
      MatIconModule,
      MatCardModule,
      MatMenuModule,
      MatSelectModule,
      MatButtonToggleModule,
      MatSlideToggleModule,
      MatProgressSpinnerModule,
      MatDialogModule,
      MatSnackBarModule,
      MatTabsModule,
      MatSidenavModule,
      MatTooltipModule,
      MatRippleModule,
      MatRadioModule,
      MatGridListModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatSliderModule,
      MatAutocompleteModule,
      /** Covalent Modules */
      CovalentCommonModule,
      CovalentLayoutModule,
      CovalentMediaModule,
      CovalentExpansionPanelModule,
      CovalentStepsModule,
      CovalentDialogsModule,
      CovalentLoadingModule,
      CovalentSearchModule,
      CovalentPagingModule,
      CovalentNotificationsModule,
      CovalentMenuModule,
      AngularEditorModule,
      CovalentDataTableModule,
      CovalentMessageModule,
      CovalentFileModule,
      ToastrModule.forRoot(),
      AngularEditorModule,
      MatProgressButtonsModule.forRoot(),
      HttpClientModule,
      NgbAccordionModule,
      DragDropModule,
      AgGridModule,
      OverlayModule,
      SharedModule,
      TranslateModule.forRoot({
         loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
         }
      })
   ],
   providers: [
      { provide: APP_INITIALIZER, useFactory: appInitializeEnv, multi: true, deps: [EnvService]},
      // { provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [AuthenticationService] },
      { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
      // { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true, deps: [LoadingService] },
      { provide: LOCALE_ID, useValue: 'fr-FR' },
      { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
      { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
      JwtHelperService,
      DatePipe
   ],
   bootstrap: [AppComponent],
   schemas: [CUSTOM_ELEMENTS_SCHEMA],
   exports: [MatButtonModule, MatDialogModule, DragDropModule]
})
export class AppModule {}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
   return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
